import { useMemo, useState } from "react"
import { Drawer, Menu } from "antd"
import { useLocation, useNavigate } from "react-router-dom"
import { CloseCircle, HambergerMenu } from "iconsax-react"
import MENU from "./MenuJson"
import { useSelector } from "react-redux"
import {
  filterMenuByAccess,
  findOpenKeys,
  findSelectedKeys,
  toAntdMenuItems,
} from "./filterMenu"

const MainMenu = () => {
  const userInfo = useSelector((state) => state.user.data)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const filtered = useMemo(
    () => filterMenuByAccess(MENU, userInfo),
    [userInfo]
  )
  const items = useMemo(() => toAntdMenuItems(filtered), [filtered])
  const selectedKeys = findSelectedKeys(filtered, location.pathname)
  const openKeys = findOpenKeys(filtered, location.pathname)

  const showDrawer = () => setOpen(true)
  const onClose = () => setOpen(false)

  const handleMenuClick = ({ key }) => {
    if (key.startsWith("/")) {
      navigate(key)
      onClose()
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={showDrawer}
        className="app-header__icon-btn"
        aria-label="Open navigation"
      >
        <HambergerMenu size="18" color="#94a3b8" />
      </button>
      <Drawer
        title={
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fs-5 m-0 text-white">Navigation</h5>
            <span onClick={onClose} style={{ cursor: "pointer" }}>
              <CloseCircle size="22" color="#94a3b8" />
            </span>
          </div>
        }
        closable={false}
        onClose={onClose}
        open={open}
        placement="left"
        className="device-manager"
        styles={{
          body: { background: "#0a0e17" },
          header: { background: "#0a0e17", borderBottom: "1px solid rgba(148,163,184,0.14)" },
        }}
      >
        <Menu
          className="main-menu"
          mode="inline"
          theme="dark"
          inlineIndent={16}
          items={items}
          selectedKeys={selectedKeys}
          defaultOpenKeys={openKeys}
          onClick={handleMenuClick}
        />
      </Drawer>
    </>
  )
}

export default MainMenu
